function ReadMoreButton({ onClick, text = "Leggi di piú" }) {
  return (
    <div id="read-more-button">
      <button className="learn-more" onClick={onClick}>
        <span className="circle" aria-hidden="true">
          <span className="icon arrow"></span>
        </span>
        <span className="button-text">{text}</span>
      </button>
    </div>
  );
}

export default ReadMoreButton;
